import { render } from "./ChangeName.vue?vue&type=template&id=75f85042&scoped=true"
import script from "./ChangeName.vue?vue&type=script&lang=js"
export * from "./ChangeName.vue?vue&type=script&lang=js"

import "./ChangeName.vue?vue&type=style&index=0&id=75f85042&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75f85042"

export default script